import React from "react";
import { FullPageChat } from "@zeemee/react-web-chat";
import { useParams } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { Status, statusVar } from "@/reactiveVars/chat";
import { LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export const Chat = () => {
  const { t } = useTranslation();
  const { chat } = useParams();
  const { navToRoute } = useProtectedNavigation();

  const status = useReactiveVar(statusVar);

  return (
    <div className="absolute h-full w-full">
      {status === Status.BOOTSTRAP_IN_PROGRESS && (
        <div className="flex h-full items-center justify-center">
          <span className="sr-only">{t("global.loading")}</span>
          <LoaderCircle className="animate-spin" />
        </div>
      )}
      {status === Status.BOOTSTRAP_ERROR && (
        <div className="flex h-full items-center justify-center">
          {t("error.user")}
        </div>
      )}
      {status === Status.BOOTSTRAP_SUCCESS && (
        <FullPageChat
          selectedChat={chat || null}
          onSelectedChatChange={(chat) =>
            navToRoute("selectedChat", { chat: chat || "" })
          }
        />
      )}
    </div>
  );
};
